export default __webpack_public_path__ + "static/media/emptyBetslip.d34d4ebe.png";